import React from 'react'

import styled from '@emotion/styled'

export type FieldLabelProps = {
  label: string
  space?: string
  tooltip?: React.ReactNode
  children?: React.ReactNode
  htmlFor?: string
  className?: string
}

const Tooltip = styled.span`
  margin-left: 1rem;
  align-self: flex-start;
  height: 1.5rem;
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.secondaryLabel};
`

const StyledLabel = styled.label<{ disabled: boolean }>`
  -webkit-tap-highlight-color: transparent;
  color: ${({ disabled, theme }) => (disabled ? theme.colors.disabledLabel : theme.colors.secondaryLabel)};

  &:has(input:disabled) {
    color: ${props => props.theme.colors.disabledLabel};
  }
`

const LabelText = styled.span`
  ${props => props.theme.typography.smallTitle}
`

const LabelLayout = styled.span<{ space: string }>`
  display: flex;
  justify-content: space-between;
  margin: 0rem 0.5rem ${props => props.space};

  ${props => props.theme.breakpoints.tablet} {
    justify-content: flex-start;
  }
`

const FieldLabel: React.FC<FieldLabelProps> = ({ label, children, tooltip, space = '0.5rem', ...props }) => {
  /* Waiting on firefox to support :has() to be able to remove this check https://developer.mozilla.org/en-US/docs/Web/CSS/:has#browser_compatibility */
  const disabled = React.Children.toArray(children).some(
    child => typeof child === 'object' && 'props' in child && child.props.disabled === true
  )

  return (
    <StyledLabel disabled={disabled} {...props}>
      <LabelLayout space={space}>
        <LabelText>{label}</LabelText>
        {tooltip && <Tooltip>{tooltip}</Tooltip>}
      </LabelLayout>
      {children}
    </StyledLabel>
  )
}

export default FieldLabel
